import React from 'react';
import { IonGrid, IonRow, IonCol, IonContent } from '@ionic/react';
import LoginForm from "./LoginForm";
import "../styles/Login.css";
import calyanlogo from "../assets/logos/calyanLogo.svg";

const Login = () => (
  <IonContent>
    <IonGrid className="grid login-page-root">
      <IonRow style={{ height: '100vh', margin: 0 }}>
        <IonCol className="column login-form-section" style={{ flex: '0 0 60%' }}>
          <LoginForm />
        </IonCol>
        <IonCol
          className="login-logo-section"
          style={{ flex: '0 0 40%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: '340px', height: '100%' }}
        >
          <img
            src={calyanlogo}
            alt="Calyan Logo"
            className="calyan-logo"
            style={{
              width: '300px',
              height: '300px',
              display: 'block',
              margin: '0 auto'
            }}
          />
        </IonCol>
      </IonRow>
    </IonGrid>
  </IonContent>
);

export default Login;
